export enum MovementDirection {
    UP,
    DOWN
}

function arrayMove(array: [] | undefined, selectedItems: [], movementDirection: MovementDirection): [] | null {
    if (!array || !selectedItems) return null
    let moveBy = 0
    switch (movementDirection) {
        case MovementDirection.UP:
            moveBy = -1
            break
        case MovementDirection.DOWN:
            moveBy = 1
            break
        default:
            moveBy = 0
    }

    // We have to sort the array of selected items by their indexes so that the following implementation would work.
    const sortedSelectedItems = selectedItems.sort(
        (firstItem, secondItem) => array.indexOf(firstItem) - array.indexOf(secondItem)
    )

    // if moving down - reverse the array so that the second item doesn't overwrite the first
    // this is needed when adjacent items are selected
    if (moveBy > 0) sortedSelectedItems.reverse()

    sortedSelectedItems.forEach((item) => {
        const index = array.indexOf(item)
        const newIndex = index + moveBy

        if (newIndex > -1 && newIndex < array.length) {
            // Remove the item from the array
            const removedElement = array.splice(index, 1)[0]

            // At "newIndex", remove 0 elements, insert the removed element
            array.splice(newIndex, 0, removedElement)
        }
    })

    return array
}

const arraySwap = <T extends unknown>(array: Array<T>, indexA: number, indexB: number): Array<T> => {
    array[indexA] = array.splice(indexB, 1, array[indexA])[0]
    return array
}

export { arrayMove, arraySwap }
